let rootURI = process.env.REACT_APP_ROOT_URI;
if (process.env.NODE_ENV === "development") {
    rootURI = rootURI + ":3000";
}

// Project contains a list of projects that
// are meant to be served from the server that
// this code is deployed on
const module = await import("./default_configs/projects.json", {
    with: { type: 'json' },
})
const projects = module.default['projects'];

const NoPage = () => {
  return <h1>Please provide an existing project name, e.g. {rootURI}/{projects[0]} </h1>;
};

export default NoPage;
